import { z } from 'zod'

export default z.object({
  __typename: z.literal('PersonContact').default('PersonContact'),
  id: z.string(),
})
